
import { Container, Stack, Unstable_Grid2 as Grid } from '@mui/material';
import { Layout as DashboardLayout } from '../Profile/layout'
//import { AccountProfileDetails } from './account-profile-details';
//import StrategiesList from '../Profile/Commitment_List';
//import StrategiesList from '../../components/CommitmentList/Commitment_List_View'
import StrategiesList from './Strategies_List_View'
import StrategiesListEdit from './Strategies_List_Edit'
import {
  Avatar,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Divider,
  Typography,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


import React, { useState, useEffect, useContext } from "react";
import {Link, useNavigate} from 'react-router-dom';
import { UserContext } from "../../context/UserContext";
import Iconify from '../../common/Iconify/Iconify'
import { BASE_URL } from '../../baseUrl'



const StrategiesPage = () => {

  const [login, setLogin] = useContext(UserContext);
  const isLoggedIn = login.isLoggedIn;
  const [loaded, setLoaded] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  //const [UserBio, setUserBio] = useState("");
  const [Commitments, setCommitments] = useState([]);
  const [activeModal, setActiveModal] = useState(false);
  //const [activeModalBio, setActiveModalBio] = useState(false);
  const [idstrategy, setIdStrategy] = useState(null);
  const [selectedStrategy, setSelectedStrategy] = useState(null);
  const [modalflag, setModalFlag]= useState(null);
  const navigate = useNavigate();

  //Accordion constants
  const [expanded, setExpanded] = useState('panel1'); 

  useEffect(() => {
    // Set the first accordion to be expanded by default
    setExpanded('panel1');
    console.log('Effect for accordion')
  }, []);

  const handleChange = (panel) => (event, isExpanded) => {
      setExpanded(isExpanded ? panel : false);
  };
  /////

  const handleLogout = () => {
          //setToken(null);
          setLogin({ token: null, isLoggedIn: false });
      
          // Clear local storage
          localStorage.removeItem('tkn_2050');
      
          // Navigate back to home page or login page
          navigate('/');    
  };
  

  const getProfile = async ()=>{
      const requestOptions = {
          method: "GET",
          headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + login.token,
          },
      };
      
      const response = await fetch(BASE_URL+"/api/strategy/list", requestOptions);
          if (!response.ok) {
              setErrorMessage("Something went wrong. Couldn't load the profile data");
          } else {
              const data = await response.json();
              console.log("***data retrieve for strategies*****")
              console.log(data)
              setCommitments(data);
              setLoaded(true);
          }

  }


  useEffect(() => {
    //This code helps to scroll to the top when the screen is open
    window.scrollTo(0, 0);
    console.log("valor de ID_user")
    console.log(login.id_user)
    getProfile()
    console.log('Effect for loading profile')
  }, []);

  const onSubmitReloadAll = (trigger) => {
    if (trigger) {
      getProfile()
    }
  }

  return(
    <>
      <Card 
        sx={{ bgcolor: '#B3B8CD',
              minWidth: '300px',
              padding: '1rem 3%',
              marginX: '5%',
              marginTop: '2rem'
            }} >

<CardContent>
  <Grid container direction="column" spacing={2}>
    <Grid item>
      <Typography variant="h4" color='black'>Managing Strategies (LISAs & LIRAs) ...</Typography>
    </Grid>
    <Grid item>
      <div className="cards-container" style={{ display: 'flex' }}>
        <Card style={{ flex: 1, marginRight: '1rem' }}>
          <CardContent>
            <Typography variant="h6" color='black'>DEMO STRATEGIES</Typography>
            <Typography variant="body1" color='black'>Any user of the 2050 Dashboard Platform is able to access the "DEMO" strategies to ease understanding of how the platform works. These are "view-only" strategies (can not be changed). </Typography>
          </CardContent>
        </Card>
        <Card style={{ flex: 1, marginRight: '1rem' }}>
          <CardContent>
            <Typography variant="h6" color='black'>PUBLIC STRATEGIES</Typography>
            <Typography variant="body1" color='black'>Any user of the Platform has access to view all "PUBLIC" strategies. This is non-private data generated by all other users. If you generate a "public" strategy, it will be viewed by any user of the Dashboard platform.</Typography>
          </CardContent>
        </Card>
        <Card style={{ flex: 1 }}>
          <CardContent>
            <Typography variant="h6" color='black'>PRIVATE (EDITABLE) STRATEGIES</Typography>
            <Typography variant="body1" color='black'>"PRIVATE" Strategies can be viewed and edited by the user who originated them. This will be only accessible to you, unless you decide to grant access to other users.</Typography>
            <Typography variant="body1" color='black'>When granting access of your "PRIVATE" strategies, the user that receives access can view and/or edit these depending on the level of permission granted.</Typography>
          </CardContent>
        </Card>
      </div>
    </Grid>

  </Grid>
</CardContent>
      </Card>


      {/* Profile layout */}
      <Box component="main"  sx={{flexGrow: 1,py: 8}}>
        <div>
          <Grid  container spacing={5} direction="column" alignItems="center">      
            
            {/* Grid Object to display accordions */}
            <Grid xs={11} md={9} lg={9}>
              
              <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: 'white' }}/>}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                  sx={{ backgroundColor: '#444', opacity: '99%' }}
                >
                  <Typography sx={{ width: '33%', flexShrink: 0, color: 'white' }} >
                    DEMO STRATEGIES
                  </Typography>
                  <Typography sx={{ color: 'lightgray' }}>Get familiar with the tool...</Typography>

                </AccordionSummary>

                <AccordionDetails sx={{ backgroundColor: '#444', opacity: '99%' }}>
                  <Grid >
                    <StrategiesList
                      title="Strategies"
                      list={Commitments && Commitments.demo && Commitments.demo.length > 0 ? Commitments.demo[0].strategy_list : []}
                      id_client = {(Commitments.demo && Commitments.demo.length > 0) ? Commitments.demo[0].ID_Client : null}
                  /> </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: 'white' }}/>}
                  aria-controls="panel2bh-content"
                  id="panel2bh-header"
                  sx={{ backgroundColor: '#444', opacity: '97%' }}
                >
                  <Typography sx={{ width: '33%', flexShrink: 0, color: 'white' }}>PUBLIC STRATEGIES</Typography>
                  <Typography sx={{ color: 'lightgray' }}>
                    View Only (from other users)
                  </Typography>

                </AccordionSummary>
                
                <AccordionDetails sx={{ backgroundColor: '#444', opacity: '97%' }}>
                  <Grid container spacing={2}>
                    {Commitments && Commitments.Public && Commitments.Public.length > 0 ? (
                      Commitments.Public.map((group, index) => (
                        <Grid item xs={12} key={index}>
                          
                          <StrategiesList
                            title={`Group ${index + 1} - ${group.Name}`}
                            list={group.strategy_list}
                            id_client = {group.ID_Client}
                          />
                        </Grid>
                      ))
                    ) : (
                      
                      <Typography color='whitesmoke' sx={{padding: '2rem'}} >No Public Strategies Available -- Check "My Strategies" section below</Typography>
                    )}
                  </Grid>
                </AccordionDetails>

              </Accordion>

              <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: 'white' }}/>}
                  aria-controls="panel3bh-content"
                  id="panel3bh-header"
                  sx={{ backgroundColor: '#444', opacity: '95%' }}
                >
                  <Typography sx={{ width: '33%', flexShrink: 0, color: 'white' }}>
                    MY STRATEGIES
                  </Typography>
                  <Typography sx={{ color: 'lightgray' }}>
                    Editable strategies (you own and/or have control)
                  </Typography>
                </AccordionSummary>

                <AccordionDetails sx={{ backgroundColor: '#444', opacity: '97%' }}>
                               
                  <Grid container spacing={2}>
                    {Commitments.Private && Commitments.Private.length > 0 ? (
                    
                      Commitments.Private.map((group, index) => (
                        <Grid item xs={12} key={index}>
                          
                          <StrategiesListEdit
                            title={`Group ${index + 1} - ${group.Name}`}
                            list={group.strategy_list}
                            id_client = {group.ID_Client}
                            onSubmitReloadAll = {onSubmitReloadAll}
                          />
                        </Grid>
                      ))
                    ) : (
                      <Typography color='whitesmoke' sx={{padding: '2rem'}} >No Private Strategies Available -- Become a Signatory thru your Profile Manager page </Typography>
                      
                    )}
                  </Grid>
                
                </AccordionDetails>

              </Accordion>

            </Grid>
          </Grid>

        </div>

      </Box>

    </>
  );
}

StrategiesPage.getLayout = (page) => (
  <DashboardLayout>
    {page}
  </DashboardLayout>
);
  
export default StrategiesPage;